import { gql } from "apollo-boost";

export const SUPER_ADMIN_LIST = gql`
  query {
    getListOfSuperAdmins {
      id
      userId {
        Id
        entityType
      }
      name
      portalType
      createdBy {
        loginId
      }
      createdOn
    }
  }
`;

export const DELETE_SUPER_ADMIN = gql`
  mutation($id: String) {
    deleteSuperAdmin(id: $id) {
      message
    }
  }
`;

export const ADD_SUPER_ADMIN = gql`
  mutation($userId: Int, $portalType: Int) {
    createSuperAdmin(data: { superAdmin: $userId, portalType: $portalType }) {
      user {
        id
      }
    }
  }
`;
